import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { TranslationKeys } from "../../../../translations";
import { HasAccessTo } from "app/components/Authorization";
import { ROLE } from "../../../../common/Authorization/entities";
import { EDIT } from "../../../../common/Authorization/permissions";
import { DivRootStyled } from "./RolesToolbar.styles";
import { ActionButton } from "../../../../components/ActionButton";
const RolesToolbar = (props) => {
  const { className, handleClickAdd, totalCount } = props;
  const disabledIfNoAccessToRoleEdit = !HasAccessTo(ROLE, EDIT);
  return /* @__PURE__ */ React.createElement(DivRootStyled, { className }, /* @__PURE__ */ React.createElement(Grid, { container: true, spacing: 3 }, /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 8 }, /* @__PURE__ */ React.createElement(Typography, { variant: "h5" }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: TranslationKeys.menu_roles })), /* @__PURE__ */ React.createElement(Typography, { variant: "subtitle2", textTransform: "uppercase" }, /* @__PURE__ */ React.createElement(FormattedMessage, { id: TranslationKeys.roles_totalCount, values: { totalCount } }))), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 4, sx: { display: "flex", justifyContent: "flex-end" } }, /* @__PURE__ */ React.createElement(
    ActionButton,
    {
      messageId: TranslationKeys.roles_add,
      icon: faPlus,
      onClick: handleClickAdd,
      disabled: disabledIfNoAccessToRoleEdit
    }
  ))));
};
RolesToolbar.propTypes = {
  className: PropTypes.string,
  handleClickAdd: PropTypes.func.isRequired,
  totalCount: PropTypes.number.isRequired
};
export default RolesToolbar;
